import axiosConfig from '../../../utils/axiosConfig';
import {
  clearHolidayStatus,
  createHolidayFailure,
  createHolidayRequest,
  createHolidaySuccess,
  deleteHolidayFailure,
  deleteHolidayRequest,
  deleteHolidaySuccess,
  fetchHolidaysFailure,
  fetchHolidaysRequest,
  fetchHolidaysSuccess,
  updateHolidayFailure,
  updateHolidayRequest,
  updateHolidaySuccess
} from '../holidayAction';

const apiUrl = process.env.REACT_APP_API_URL;

const normalizeError = (error) => error.response?.data?.message || error.message || 'Tuntematon virhe';

export const fetchHolidays = () => async (dispatch) => {
  try {
    dispatch(fetchHolidaysRequest());
    const response = await axiosConfig.get(`${apiUrl}/holidays`);
    dispatch(fetchHolidaysSuccess(response.data));
  } catch (error) {
    dispatch(fetchHolidaysFailure(normalizeError(error)));
  }
};

export const createHoliday = ({ person, startDate, endDate }) => async (dispatch) => {
  try {
    dispatch(createHolidayRequest());
    const response = await axiosConfig.post(`${apiUrl}/holidays`, {
      person,
      startDate,
      endDate
    });
    dispatch(createHolidaySuccess(response.data));
  } catch (error) {
    dispatch(createHolidayFailure(normalizeError(error)));
  }
};

export const updateHoliday = (holidayId, { person, startDate, endDate }) => async (dispatch) => {
  try {
    dispatch(updateHolidayRequest());
    const response = await axiosConfig.put(`${apiUrl}/holidays/${holidayId}`, {
      person,
      startDate,
      endDate
    });
    dispatch(updateHolidaySuccess(response.data));
  } catch (error) {
    dispatch(updateHolidayFailure(normalizeError(error)));
  }
};

export const removeHoliday = (holidayId) => async (dispatch) => {
  try {
    dispatch(deleteHolidayRequest(holidayId));
    await axiosConfig.delete(`${apiUrl}/holidays/${holidayId}`);
    dispatch(deleteHolidaySuccess(holidayId));
  } catch (error) {
    dispatch(deleteHolidayFailure(normalizeError(error)));
  }
};

export const clearHolidayAlerts = () => (dispatch) => {
  dispatch(clearHolidayStatus());
};
